import { DataGrid, MUIButton, MUIDialog, Notification } from '@abb/arcadia-ui-react';
import { requestSiteGetById, requestSitePut } from '@service/siteDataService';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import * as ActionCreators from '../../actionCreators/licenseAllowanceActionCreators';

// Site fields that are sourced from ServIS and can drift from the database.
const SERVIS_COMPARE_FIELDS = [
      { key: 'siteName', label: 'Site Name' },
      { key: 'owner', label: 'Owner' },
      { key: 'operator', label: 'Operator' },
      { key: 'regionName', label: 'Region' },
      { key: 'country', label: 'Country' },
      { key: 'city', label: 'City' }
];

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
export class CustomerSite extends React.Component<any, any> {
      constructor(props: any) {
            super(props);

            this.state = {
                  isUpdating: false,
                  saveError: false,
                  saveSuccess: false,
                  isChecking: false,
                  upToDateInfo: false,
                  showDialog: false,
                  dismissedMismatch: false,
                  differences: [],
                  servIsSite: null,
                  overrideSite: null,
                  checkedServIsId: null
            };
      }

      render() {

            const hasMismatch = this.state.differences.length > 0;
            const button = this.props.userPermissions?.isAdmin
            ?  (
                  <div className='col-md-2 text-right align-bottom'>
                        <MUIButton variant={hasMismatch ? 'primary' : 'secondary'} size={32} iconName='icon_abb_dias icon-abb_refresh'
                              label={hasMismatch ? 'Review ServIS Update' : 'Update Site'}
                              onClickButton={this.handleUpdateClick} disabled={this.state.isUpdating || this.state.isChecking} />
                  </div>
               )
            : null;
            const site = this.getSite();
            const headerData = [
                  { id: 'field', label: 'Field', numeric: false, actions: false, enableSort: false },
                  { id: 'value', label: 'Value', numeric: false, actions: false, enableSort: false }
            ];
            const rows = [
                  { id: 'site', field: 'Site', value: site.siteName ? site.siteName : '' },
                  { id: 'owner', field: 'Owner', value: site.owner ? site.owner : '' },
                  { id: 'city', field: 'City', value: site.city ? site.city : '' },
                  { id: 'region', field: 'Region', value: site.regionName ? site.regionName : '' },
                  { id: 'servisId', field: 'ServIS ID', value: site.servIsId ? site.servIsId : '' },
                  { id: 'operator', field: 'Operator', value: site.operator ? site.operator : '' },
                  { id: 'country', field: 'Country', value: site.country ? site.country : '' },
                  { id: 'servicePorts', field: 'ServicePorts', value: this.props.numberOfSavedServers }
            ];
            const diffHeader = [
                  { id: 'field', label: 'Field', numeric: false, actions: false, enableSort: false },
                  { id: 'current', label: 'Current (Database)', numeric: false, actions: false, enableSort: false },
                  { id: 'servis', label: 'ServIS Value', numeric: false, actions: false, enableSort: false }
            ];
            const diffRows = this.state.differences.map((d: any, i: number) => ({
                  id: String(i), field: d.field, current: d.current || '(empty)', servis: d.servIs || '(empty)'
            }));
            const dialogContent = (
                  <div>
                        <p>The following site details differ from ServIS. Choose <strong>Update Site Information</strong> to refresh them from ServIS, or <strong>Keep Current</strong> to leave the site unchanged.</p>
                        <p><strong>Existing licenses and hardware will not be affected.</strong></p>
                        <DataGrid name='servis-differences' enableCheckbox={false} size={40} rowsPerPage={diffRows.length || 1} headerData={diffHeader} rows={diffRows} />
                  </div>
            );
            return (
                  <div>
                        {this.state.saveError ? (
                              <Notification
                                    variant='error'
                                    isBanner={true}
                                    open={true}
                                    id='siteUpdateErrorBanner'
                                    primaryText='Unable to update site from ServIS. Please try again.'
                                    onClose={this.handleDismissNotification}
                              />
                        ) : null}
                        {this.state.saveSuccess ? (
                              <Notification
                                    variant='success'
                                    isBanner={true}
                                    open={true}
                                    id='siteUpdateSuccessBanner'
                                    primaryText='Site data refreshed from ServIS.'
                                    onClose={this.handleDismissNotification}
                              />
                        ) : null}
                        {hasMismatch && !this.state.showDialog && !this.state.dismissedMismatch ? (
                              <Notification
                                    variant='warning'
                                    isBanner={true}
                                    open={true}
                                    id='siteMismatchBanner'
                                    primaryText="This site's information differs from ServIS. Use 'Review ServIS Update' to view and apply the changes; existing licenses and hardware are not affected."
                                    onClose={this.handleDismissMismatchBanner}
                              />
                        ) : null}
                        {this.state.upToDateInfo ? (
                              <Notification
                                    variant='neutral'
                                    isBanner={true}
                                    open={true}
                                    id='siteUpToDateBanner'
                                    primaryText='Site information already matches ServIS. No update needed.'
                                    onClose={this.handleDismissNotification}
                              />
                        ) : null}
                        <div className='container container-style card-container padding-bottom'>
                              <div className='row flex-between'>
                                    <div className='col-md-10'>
                                          <div>
                                                <h3>Customer Site</h3>
                                          </div>
                                    </div>
                                    <div>
                                          {button}
                                    </div>
                              </div>
                              <div className='row top-buffer'>
                                    <div className='col-md-12'>
                                          <DataGrid
                                                name='customer-site'
                                                size={40}
                                                enableCheckbox={false}
                                                rowsPerPage={rows.length}
                                                headerData={headerData}
                                                rows={rows}
                                          />
                                    </div>
                              </div>
                        </div>
                        <MUIDialog
                              variant='warning'
                              open={this.state.showDialog}
                              heading='Update Site From ServIS'
                              content={dialogContent}
                              primaryButtonText='Update Site Information'
                              onClickPrimaryButton={this.applyUpdate}
                              secondaryButtonText='Keep Current'
                              secondaryButtonConfig={{ onClick: this.closeDialog }}
                              onClose={this.closeDialog}
                        />
                  </div>
            );
      }

      componentDidMount() {
            this.maybeCheckForMismatch();
      }

      componentDidUpdate() {
            this.maybeCheckForMismatch();
      }

      getSite = () => {
            return this.state.overrideSite || this.props.site || {};
      }

      // Runs the ServIS comparison once, when the site (servIsId) first becomes available.
      maybeCheckForMismatch = () => {
            const site = this.props.site || {};
            if (this.props.userPermissions?.isAdmin && site.servIsId && this.state.checkedServIsId !== site.servIsId) {
                  this.setState({ checkedServIsId: site.servIsId }, this.checkForMismatch);
            }
      }

      checkForMismatch = async () => {
            const site = this.getSite();
            if (!site.servIsId) { return; }
            try {
                  const { servIsSite, differences } = await this.fetchServIsDifferences(site);
                  this.setState({ differences, servIsSite, dismissedMismatch: false });
            } catch (err) {
                  // ServIS unreachable: don't block the page, just skip the mismatch banner.
            }
      }

      computeDifferences = (dbSite: any, servIsSite: any) => {
            const norm = (v: any) => (v === null || v === undefined ? '' : String(v).trim());
            return SERVIS_COMPARE_FIELDS
                  .map((f: any) => ({ field: f.label, key: f.key, current: norm(dbSite[f.key]), servIs: norm(servIsSite[f.key]) }))
                  .filter((d: any) => d.current !== d.servIs);
      }

      // Fetch the current ServIS site and diff it against the local site record.
      fetchServIsDifferences = async (site: any) => {
            const servIsSite: any = await requestSiteGetById(site.servIsId, this.props.accessToken);
            return { servIsSite, differences: this.computeDifferences(site, servIsSite) };
      }

      // Admin clicked the button: refresh ServIS data, then prompt only if something differs.
      handleUpdateClick = async () => {
            const site = this.getSite();
            if (!site.id || !site.servIsId) {
                  this.setState({ saveError: true, saveSuccess: false });
                  return;
            }
            this.setState({ isChecking: true, saveError: false, saveSuccess: false, upToDateInfo: false });
            try {
                  const { servIsSite, differences } = await this.fetchServIsDifferences(site);
                  if (differences.length === 0) {
                        this.setState({ isChecking: false, differences: [], servIsSite, upToDateInfo: true });
                  } else {
                        this.setState({ isChecking: false, differences, servIsSite, showDialog: true });
                  }
            } catch (err) {
                  this.setState({ isChecking: false, saveError: true });
            }
      }

      // User confirmed: pull latest site data from ServIS and persist the changed fields.
      applyUpdate = async () => {
            const site = this.getSite();
            this.setState({ isUpdating: true, saveError: false, saveSuccess: false });
            try {
                  await requestSitePut(site.id, site.servIsId, this.props.accessToken);
                  this.props.updateSite(site.id, this.props.accessToken);
                  const merged = { ...site, ...(this.state.servIsSite || {}) };
                  this.setState({ isUpdating: false, saveSuccess: true, showDialog: false, differences: [], overrideSite: merged });
            } catch (err) {
                  this.setState({ isUpdating: false, saveError: true, showDialog: false });
            }
      }

      // User declined the update: close the dialog and leave the site unchanged.
      closeDialog = () => {
            this.setState({ showDialog: false });
      }

      handleDismissNotification = () => {
            this.setState({ saveError: false, saveSuccess: false, upToDateInfo: false });
      }

      handleDismissMismatchBanner = () => {
            this.setState({ dismissedMismatch: true });
      }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerSite) as any);

export function mapStateToProps(store: any) {
      const { access_token: accessToken } = store.userState.loggedInUser;
      return { ...store.servicesState, ...store.serverState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
      return {
            updateSite: (siteId: number, accessToken: string) => dispatch(ActionCreators.onAllocationGetRequest(siteId, accessToken))
      };
}
